// extracted by css-extract-rspack-plugin
export default {"box":"uEjAE4zTNtwxbTN2","topRow":"jMslncVZeEduXbP6","heading":"vwAvWXAINUDkociW","actions":"dQbDEjuzKUAPyuYP"};